export default __webpack_public_path__ + "static/media/oppa.6899c251.pdf";